import React, { useContext } from "react";
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import { UserContext } from "../../context/UserContext";
import xplanLabels from "../../util/XplanLabels";
import HistoryLogElement from "./HistoryLogElement";
import GroupBDRBiologists from "../FieldTags/GroupBDRBiologists";
import { checkRole } from "../../util/FormUtils";
import ROLES from "../../util/roles";

const newPlan = window.location.pathname === "/xplans/new";

const ApprovalMessageRequired = ({ approvalMessageRequired, handleChange, xplans, required }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, ROLES.ELEVATED);

    return (
        <div id="approvalMessageRequired" className="planField">
            <GroupBDRBiologists />
            <FormControl>
                <FormLabel className="planRadioTitle" required={required.includes("approvalMessageRequired")}>
                    {xplanLabels.approvalMessageRequired}
                </FormLabel>
                <RadioGroup
                    name="approvalMessageRequired"
                    label={xplanLabels.approvalMessageRequired}
                    value={approvalMessageRequired}
                    onChange={(e) => handleChange("approvalMessageRequired", e.target.value)}
                    row
                >
                    <FormControlLabel
                        value="Yes"
                        control={<Radio disabled={!canEdit} />}
                        label="Yes"
                    />
                    <FormControlLabel
                        value="No"
                        control={<Radio disabled={!canEdit} />}
                        label="No"
                    />
                </RadioGroup>
            </FormControl>
            {!newPlan && <HistoryLogElement xplans={xplans} label={"approvalMessageRequired"} /> }
        </div>
    );
};

export default ApprovalMessageRequired;